import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {getOpenShipping} from "../../api/shipping";

import {DocumentSearchIcon, TruckIcon} from '@heroicons/react/outline'
import {getFormattedDate} from "../../utils/timeUtils";
import FileCell from "../../components/common/table/file-cell";
import NumberFormat from "react-number-format";
import GalleryView from "../../components/common/popup/gallery-view";
import ReportViewer from "../../components/partials/report/report-viewer";
import {useTranslation} from "react-i18next";
import LoaderWrapper from "../../components/common/loader/loader-wrapper";
import UnderlineTab from "../../components/partials/Tabs/underline-tab";
import {ActionButton} from "../../components/layout/page-header";
import ShippingTimeline from "./shipping-timeline";
import {AIR, LAND, SEA} from "../../constants/config";
import ShippingIcon from "../../resources/icons/ShippingIcon";
import AirIcon from "../../resources/icons/AirIcon";
import IframePopup from "../../components/common/popup/iframe-popup";
import OpenContainerProducts from "./open-container-products";
import BaseExpired from "../../components/partials/restricted/base-expired";
import EmptyState, {NO_RESULT} from "../../components/states/empty-state";


const overview = 'overview';
const container = 'containers';
const document = 'documents';

const OpenShippingOverview = () => {

    let {code}  = useParams();
    const { t } = useTranslation();

    const [activeGroup, setActiveGroup] = useState(overview);

    // get Shipping
    const [isShippingDetailLoading, setShippingDetailLoading] = useState(true);
    const [detail, setDetail] = useState(null);
    const [url, setUrl] = useState(null);
    const [isOpenReportView, setOpenReportView] = useState(false);

    const [isOpenDetail, setOpenDetail] = useState(false);

    const [isOpenTracking, setOpenTracking] = useState(false);
    const [isExpired, setExpired] = useState(false);


    const shippingTypes = [
        { type: 'land', name: t("app.shippings.land_title"), containerLabel: t("app.container.truck"),   addContainerLabel: t("app.container.add_truck"),  addContainerTitle: t("app.container.new_truck"), editContainerTitle: t("app.container.edit_tuck_title"),   icon: TruckIcon },
        { type: 'sea', name: t("app.shippings.sea_title"), containerLabel: t("app.container.container"), addContainerLabel: t("app.container.add_contaienr"),  addContainerTitle: t("app.container.new_contaienr"), editContainerTitle: t("app.container.edit_title"),icon: ShippingIcon },
        { type: 'air', name: t("app.shippings.air_title"), containerLabel: t("app.container.uld"), addContainerLabel: t("app.container.add_uld"),  addContainerTitle: t("app.container.new_uld"), editContainerTitle: t("app.container.edit_uld_title"), icon: AirIcon },
    ];

    let shippingTypeMenu = shippingTypes?.find(r => r.type === (detail?.shipping_type?.code ?? '')) ?? null

    let trackCode = (detail && detail.shipping_container_tracking && detail.shipping_container_tracking.live_map_url) ? new URL(detail.shipping_container_tracking.live_map_url).searchParams.get("query") : false;

    const tabs = [
        { name: t("app.common.overview"), group: overview },
        { name: shippingTypeMenu?.containerLabel ?? '', group: container },
        { name: t("app.document.documents"), group: document },
    ];


    useEffect( () => {
        const controller = new AbortController();
        const signal = controller.signal;

        function fetchShipping(){
            setShippingDetailLoading(true);
            getOpenShipping({code: code, signal})
                .then(response => {
                    setDetail(response);
                    setShippingDetailLoading(false);
                }).catch(e => {
                e.code === 404 && setExpired(true);
                setShippingDetailLoading(false);
            });
        }


        fetchShipping();

        return () => {controller.abort();};
        // eslint-disable-next-line
    }, [code]);

    return (
       <BaseExpired isExpired={isExpired}>
           <ReportViewer
               isOpen={isOpenReportView}
               type={'document'}
               reportDetail={url?.file ?? false}
               title={url?.file_name ?? ''}
               isActiveConfirm={false}
               reportId={url?.id ?? false}
               setIsOpen={(r) => {
                   setOpenReportView(r);
               }}
           />


           <div className="flex  mx-auto max-w-full bg-white shadow h-screen">


               <LoaderWrapper isLoading={isShippingDetailLoading}>


                   <div className="relative  flex flex-col flex-1 overflow-hidden">

                       {
                           detail && detail.company_logo && (
                               <header className="bg-white border-b w-full flex items-center backdrop-blur justify-center p-3 lg:px-8">
                                       <img
                                           alt=""
                                           src={detail.company_logo.reference}
                                           className="h-12 w-auto"
                                       />
                               </header>
                           )
                       }


                       <main className="relative  flex-1  overflow-y-auto focus:outline-none  ">
                           {/* Start main area*/}
                           <div className="h-screen ">

                               <div className="bg-white">
                                   <div
                                       className="flex justify-between items-center flex-wrap gap-4 mb-6 max-w-7xl mx-auto px-4 sm:px-6 md:px-8 pt-10 ">

                                       <div>

                                           <div className={"flex items-center"}>

                                               <div className="mr-3">
                                                   {
                                                       shippingTypeMenu && (
                                                           <shippingTypeMenu.icon className={'w-10 h-10 text-blue-1000'}/>
                                                       )
                                                   }
                                               </div>

                                               <h1 className="ml-2 text-xl md:text-2xl text-blue-1000 uppercase font-bold">
                                                   Shipping #{detail?.tracking ?? ''}
                                               </h1>
                                           </div>


                                       </div>
                                       <div
                                           className="grid grid-flow-col sm:auto-cols-max justify-end gap-2 w-full sm:w-auto">
                                           <div >
                                               <ActionButton
                                                   onClick={() => {
                                                       setOpenDetail(true);
                                                   }}
                                                   text={'Timeline & ' + t("app.shipping_tracking.title")}
                                               />
                                           </div>

                                       </div>
                                   </div>

                                   <div className="mt-10 sm:mt-0">
                                       <UnderlineTab
                                           tabs={tabs}
                                           activeGroup={activeGroup}
                                           extraClass={'max-w-7xl mx-auto px-4 sm:px-6 md:px-8'}
                                           setActiveGroup={(r) => {
                                               setActiveGroup(r);
                                           }}
                                       />
                                   </div>

                               </div>


                               <div className={'max-w-7xl mx-auto px-4 sm:px-6 md:px-8'}>


                                   {
                                       activeGroup === overview && (
                                           <section className="mt-5">
                                               <div className="bg-white border">
                                                   <div className="px-4 py-5 sm:px-6">
                                                       <h2 className="text-lg leading-6 font-medium text-blue-1000">
                                                           {t("app.shippings.shipping_information")}
                                                       </h2>
                                                   </div>
                                                   <div className="border-t border-gray-200 px-4 py-5 sm:px-6">
                                                       <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">


                                                           <div className="sm:col-span-1">
                                                               <dt className="text-sm font-medium text-gray-500">{detail?.customer?.importer_reference ? t("app.shippings.customer") : t("app.supplier.supplier")}</dt>
                                                               <dd className="mt-1 text-sm text-blue-1000">{detail?.customer?.business_name ?? ''}</dd>
                                                           </div>

                                                           <div className="sm:col-span-1">
                                                               <dt className="text-sm font-medium text-gray-500">{t("app.shippings.terms_type")}</dt>
                                                               <dd className="mt-1 text-sm text-blue-1000">{detail?.terms_type?.name ?? '-'}</dd>
                                                           </div>


                                                           {
                                                               shippingTypeMenu && shippingTypeMenu.type === SEA && (
                                                                   <div className="sm:col-span-1">
                                                                       <dt className="text-sm font-medium text-gray-500">{t("app.shippings.shipping_line")}</dt>
                                                                       <dd className="mt-1 text-sm text-blue-1000">{detail?.shipping_line?.name ?? '-'}</dd>
                                                                   </div>
                                                               )
                                                           }


                                                           <div className="sm:col-span-1">
                                                               <dt className="text-sm font-medium text-gray-500">{t("app.shippings.departure_date")}</dt>
                                                               <dd className="mt-1 text-sm text-blue-1000">{getFormattedDate(detail?.departure_date ?? false)}</dd>
                                                           </div>
                                                           <div className="sm:col-span-1">
                                                               <dt className="text-sm font-medium text-gray-500">{t("app.shippings.arrival_date")}</dt>
                                                               <dd className="mt-1 text-sm text-blue-1000">{getFormattedDate(detail?.arrival_date ?? false)}</dd>
                                                           </div>

                                                           {
                                                               shippingTypeMenu && shippingTypeMenu.type === SEA && (
                                                                   <>
                                                                       <div className="sm:col-span-1">
                                                                           <dt className="text-sm font-medium text-gray-500">{t("app.shippings.departure_port")}</dt>
                                                                           <dd className="mt-1 text-sm text-blue-1000">{detail?.departure_port?.name ?? '-'}</dd>
                                                                       </div>
                                                                       <div className="sm:col-span-1">
                                                                           <dt className="text-sm font-medium text-gray-500">{t("app.shippings.arrival_port")}</dt>
                                                                           <dd className="mt-1 text-sm text-blue-1000">{detail?.arrival_port?.name ?? '-'}</dd>
                                                                       </div>
                                                                   </>
                                                               )
                                                           }

                                                           {
                                                               (shippingTypeMenu && (shippingTypeMenu.type === LAND || shippingTypeMenu.type === AIR)) && (
                                                                   <>
                                                                       <div className="sm:col-span-1">
                                                                           <dt className="text-sm font-medium text-gray-500">{t("app.shippings.departure_country")}</dt>
                                                                           <dd className="mt-1 text-sm text-blue-1000">{detail?.departure_country?.name ?? '-'}</dd>
                                                                       </div>
                                                                       <div className="sm:col-span-1">
                                                                           <dt className="text-sm font-medium text-gray-500">{t("app.shippings.departure_city")}</dt>
                                                                           <dd className="mt-1 text-sm text-blue-1000">{detail?.departure_city?.name ?? '-'}</dd>
                                                                       </div>

                                                                       <div className="sm:col-span-1">
                                                                           <dt className="text-sm font-medium text-gray-500">{t("app.shippings.arrival_country")}</dt>
                                                                           <dd className="mt-1 text-sm text-blue-1000">{detail?.arrival_country?.name ?? '-'}</dd>
                                                                       </div>
                                                                       <div className="sm:col-span-1">
                                                                           <dt className="text-sm font-medium text-gray-500">{t("app.shippings.arrival_city")}</dt>
                                                                           <dd className="mt-1 text-sm text-blue-1000">{detail?.arrival_city?.name ?? '-'}</dd>
                                                                       </div>
                                                                   </>
                                                               )
                                                           }


                                                           <div className="sm:col-span-1">
                                                               <dt className="text-sm font-medium text-gray-500">{t("app.shippings.shipper")}</dt>
                                                               <dd className="mt-1 text-sm text-blue-1000">
                                                                   {detail?.shipper ?? '-'}
                                                               </dd>
                                                           </div>
                                                           <div className="sm:col-span-1">
                                                               <dt className="text-sm font-medium text-gray-500">{t("app.shippings.consignee")}</dt>
                                                               <dd className="mt-1 text-sm text-blue-1000">
                                                                   {detail?.consignee ?? '-'}
                                                               </dd>
                                                           </div>
                                                       </dl>
                                                   </div>

                                               </div>
                                           </section>
                                       )
                                   }


                                   {
                                       activeGroup === container && (
                                           <div className="pb-20">
                                               <EmptyState isActive={(detail?.containers ?? []).length === 0} className={"border  p-3  border-flipper-grey-300 bg-flipper-grey-50 rounded-md  mt-4"}  title={t("app.no_data.no_result")} description={t("app.no_data.no_result_description")} iconWidth={'w-[125px]'} type={NO_RESULT} >
                                                   {(detail?.containers ?? []).map((container) => (
                                                       <>
                                                           <section className="my-5">
                                                               <div className="bg-white border">


                                                                   <div className="divide-y divide-gray-200">
                                                                       <div
                                                                           className="px-4 py-5 sm:px-6 flex items-center justify-between">
                                                                           <h2 className="text-lg font-medium text-gray-900">
                                                                               {
                                                                                   shippingTypeMenu.type === SEA ? (
                                                                                       <>{container.container_type.name}</>
                                                                                   ) : (
                                                                                       <>{container.delivery_type.name}</>
                                                                                   )
                                                                               }

                                                                           </h2>

                                                                           <p className="mt-1 text-md font-semibold text-blue-1000">{t("app.container.load_date")}: {container.load_date ? getFormattedDate(container.load_date) : '-'}</p>

                                                                       </div>
                                                                   </div>


                                                                   {
                                                                       (container?.gallery?.medias?.length ?? 0) > 0 && (
                                                                           <div className="border-t border-gray-200 ">
                                                                               <GalleryView
                                                                                   gallery={container?.gallery?.medias ?? []}/>
                                                                           </div>
                                                                       )
                                                                   }


                                                                   <div className="border-t border-gray-200 px-4 py-5 sm:px-6">
                                                                       <dl className="col-span-2 grid grid-cols-1 md:grid-cols-3 gap-6">


                                                                           {
                                                                               shippingTypeMenu && shippingTypeMenu.type === SEA && (
                                                                                   <>
                                                                                       <div>
                                                                                           <dt className="text-sm font-medium text-gray-500">{t("app.container.container_number")}</dt>
                                                                                           <dd className="mt-1 text-sm text-blue-1000">{container.container_number ? container.container_number : t("app.container.container_not_defined")}</dd>
                                                                                       </div>

                                                                                       <div>
                                                                                           <dt className="text-sm font-medium text-gray-500">{t("app.container.seal_number")}</dt>
                                                                                           <dd className="mt-1 text-sm text-blue-1000">{container.seal_number ? container.seal_number : t("app.container.container_not_defined")}</dd>
                                                                                       </div>
                                                                                   </>
                                                                               )
                                                                           }

                                                                           {shippingTypeMenu && shippingTypeMenu.type === LAND && (
                                                                               <>
                                                                                   <div>
                                                                                       <dt className="text-sm font-medium text-gray-500">{t("app.container.license_plate")}</dt>
                                                                                       <dd className="mt-1 text-sm text-blue-1000">{container.license_plate ? container.license_plate : t("app.container.container_not_defined")}</dd>
                                                                                   </div>

                                                                                   <div>
                                                                                       <dt className="text-sm font-medium text-gray-500">{t("app.container.trailer_number")}</dt>
                                                                                       <dd className="mt-1 text-sm text-blue-1000">{container.trailer_number ? container.trailer_number : t("app.container.container_not_defined")}</dd>
                                                                                   </div>
                                                                               </>
                                                                           )
                                                                           }


                                                                           {shippingTypeMenu && shippingTypeMenu.type === AIR && (
                                                                               <>
                                                                                   <div>
                                                                                       <dt className="text-sm font-medium text-gray-500">{t("app.container.uld_number")}</dt>
                                                                                       <dd className="mt-1 text-sm text-blue-1000">{container.uld_number ? container.uld_number : t("app.container.container_not_defined")}</dd>
                                                                                   </div>

                                                                                   <div>
                                                                                       <dt className="text-sm font-medium text-gray-500">{t("app.container.uld_type")}</dt>
                                                                                       <dd className="mt-1 text-sm text-blue-1000">{container.uld_type ? container.uld_type : t("app.container.container_not_defined")}</dd>
                                                                                   </div>

                                                                                   <div>
                                                                                       <dt className="text-sm font-medium text-gray-500">{t("app.container.seal_number")}</dt>
                                                                                       <dd className="mt-1 text-sm text-blue-1000">{container.seal_number ? container.seal_number : t("app.container.container_not_defined")}</dd>
                                                                                   </div>
                                                                               </>
                                                                           )
                                                                           }


                                                                           <div>
                                                                               <dt className="text-sm font-medium text-gray-500">{t("app.container.packaging_number")}</dt>
                                                                               <dd className="mt-1 text-sm text-blue-1000">
                                                                                   <NumberFormat
                                                                                       value={container?.box ?? 0}
                                                                                       displayType={"text"}
                                                                                       thousandSeparator={"."}
                                                                                       decimalSeparator={","}
                                                                                       decimalScale={0}
                                                                                   />
                                                                               </dd>
                                                                           </div>


                                                                           <div>
                                                                               <dt className="text-sm font-medium text-gray-500">{t("app.container.volume")}</dt>
                                                                               <dd className="mt-1 text-sm text-blue-1000">
                                                                                   <NumberFormat
                                                                                       value={container?.volume ?? 0}
                                                                                       displayType={"text"}
                                                                                       thousandSeparator={"."}
                                                                                       decimalSeparator={","}
                                                                                       decimalScale={2}
                                                                                       suffix={' m³'}
                                                                                   />
                                                                               </dd>
                                                                           </div>

                                                                           <div>
                                                                               <dt className="text-sm font-medium text-gray-500">{t("app.container.gross_weight")}</dt>
                                                                               <dd className="mt-1 text-sm text-blue-1000">
                                                                                   <NumberFormat
                                                                                       value={container?.weight ?? 0}
                                                                                       displayType={"text"}
                                                                                       thousandSeparator={"."}
                                                                                       decimalSeparator={","}
                                                                                       decimalScale={2}
                                                                                       suffix={' Kg'}
                                                                                   />
                                                                               </dd>
                                                                           </div>

                                                                           <div>
                                                                               <dt className="text-sm font-medium text-gray-500">{t("app.container.net_weight")}</dt>
                                                                               <dd className="mt-1 text-sm text-blue-1000">
                                                                                   <NumberFormat
                                                                                       value={container?.net_weight ?? 0}
                                                                                       displayType={"text"}
                                                                                       thousandSeparator={"."}
                                                                                       decimalSeparator={","}
                                                                                       decimalScale={2}
                                                                                       suffix={' Kg'}
                                                                                   />
                                                                               </dd>
                                                                           </div>

                                                                       </dl>
                                                                   </div>


                                                                   <div className={'border-t border-gray-200'}>
                                                                       <OpenContainerProducts
                                                                           containerDetail={container}
                                                                           code={code}
                                                                           isSeaType={shippingTypeMenu && shippingTypeMenu.type === SEA}
                                                                           shipping={detail}
                                                                       />
                                                                   </div>

                                                               </div>
                                                           </section>


                                                       </>

                                                   ))}
                                               </EmptyState>
                                           </div>
                                       )
                                   }


                                   {
                                       activeGroup === document && (
                                           <div className="pb-20">
                                               <EmptyState isActive={(detail?.documents ?? []).length === 0} className={"border  p-3  border-flipper-grey-300 bg-flipper-grey-50 rounded-md  mt-4"}  title={t("app.no_data.no_result")} description={t("app.no_data.no_result_description")} iconWidth={'w-[125px]'} type={NO_RESULT} >
                                                   {(detail?.documents ?? []).map((document) => (

                                                       <section key={document.id} className="">
                                                           <div className="bg-white border">

                                                               <div className="divide-y divide-gray-200">
                                                                   <div
                                                                       className="px-4 py-5 sm:px-6 flex items-center justify-between">
                                                                       <div className="w-0 flex-1 flex items-center">
                                                                           <FileCell file={document}/>
                                                                       </div>

                                                                       <div
                                                                           className="ml-4 flex-shrink-0 flex items-center justify-between">
                                                                           {
                                                                               document.file && (
                                                                                   <>
                                                                                       <div onClick={() => {
                                                                                           setUrl(document);
                                                                                           setOpenReportView(true);
                                                                                       }}
                                                                                            className="text-sm font-semibold flex items-center text-indigo-600 hover:text-indigo-900 cursor-pointer">
                                                                                           <DocumentSearchIcon
                                                                                               className={'h-5 w-5 text-blue-1000'}
                                                                                               aria-hidden="true"/>
                                                                                       </div>

                                                                                   </>
                                                                               )
                                                                           }
                                                                       </div>
                                                                   </div>
                                                               </div>
                                                           </div>
                                                       </section>

                                                   ))}
                                               </EmptyState>
                                           </div>
                                       )
                                   }

                               </div>


                           </div>
                           {/* End main area */}
                       </main>
                   </div>
               </LoaderWrapper>
           </div>


           <ShippingTimeline
               isOpen={isOpenDetail}
               events={detail?.events ?? []}
               isSeaType={shippingTypeMenu && shippingTypeMenu.type === SEA}
               tracking={detail}
               setIsOpen={(r) => {
                   setOpenDetail(r);
               }}
               onOpenTracking={(r) => {
                   setOpenTracking(r);
               }}
           />

           {
               isOpenTracking && (
                   <IframePopup
                       isOpen={isOpenTracking}
                       setIsOpen={setOpenTracking}
                       trackingLink={trackCode ? `https://shipsgo.com/iframe/where-is-my-container/${trackCode}?tags=hide-search-box` : detail.tracking_link}
                   />
               )
           }

       </BaseExpired>
    );
};

export default OpenShippingOverview;
